import * as React from 'react';
import styled from 'styled-components';
import { CalculatorResultsTableProps } from '../../models';
import BREAK_POINTS from '../../../../styling/media-queries';
import getPartnerAsset, { getPartnerResource, DynamicAssetsKeys } from '../../../../assets';

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 20px;
  min-width: 0;
  @media ${BREAK_POINTS.desktop} {
    min-width: 871px;
  }
`;

const FeatureBase = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  line-height: 1.2;
  height: 75px;
  width: 100%;
  &:last-child {
    border-bottom: none;
  }
  @media ${BREAK_POINTS.mobileBig} {
    font-size: 14px;
  }
  @media ${BREAK_POINTS.tablet} {
    font-size: 16px;
  }
`;

const FeatureQuestion = styled(FeatureBase)`
  justify-content: flex-start;
  text-align: left;
  font-weight: 600;
  @media ${BREAK_POINTS.tablet} {
    padding-left: 10px;
  }
`;

const FeatureAsurion = styled(FeatureBase)`
  color: ${(props) => props.theme.colors.primaryAccentFontColor};
  border-bottom-color: ${(props) => props.theme.colors.primaryAccentFontColor};
  @media ${BREAK_POINTS.tabletBig} {
    border-bottom: none;
  }
`;

const FeatureCompetitor = styled(FeatureBase)``;

const ColumnBase = styled.div<{ hasShadow?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  box-sizing: border-box;
  box-shadow: ${(props) => (props.hasShadow === true ? '0px 0px 10px rgba(0, 0, 0, 0.15)' : 'none')};
  background: #fefefe;
  @media ${BREAK_POINTS.mobileBig} {
    min-width: 119px;
  }
  @media ${BREAK_POINTS.desktop} {
    width: 277px;
  }
`;

const QuestionsColumn = styled(ColumnBase)`
  margin-top: 98px;
  justify-content: left;
  text-align: left;
  padding-right: 10px;
  @media ${BREAK_POINTS.mobileBig} {
    padding-right: 20px;
  }
`;

const AsurionColumn = styled(ColumnBase)`
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 30px;
  margin-right: 10px;
  min-width: 95px;
  background: ${(props) =>
    `linear-gradient(180deg, ${props.theme.colors.gradient1Light} -24.61%, ${props.theme.colors.gradient1Dark} 100%)`};
  @media ${BREAK_POINTS.mobileBig} {
    margin-right: 20px;
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const CompetitorColumn = styled(ColumnBase)`
  padding: 0 10px;
  min-width: 101px;
  @media ${BREAK_POINTS.mobileBig} {
    padding: 0 15px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  width: 100%;
  height: 98px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;

const IndividualWarranties = styled.div`
  display: flex;
  align-items: center;
  height: 98px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  @media ${BREAK_POINTS.mobile} {
    font-size: 16px;
  }
`;

const CalculatorResultsTable: React.FunctionComponent<CalculatorResultsTableProps> = ({ competitionMonthlyPrices }) => {
  const maxPrice: number = Math.max(...Object.values(competitionMonthlyPrices));
  const Logo: React.FC = getPartnerAsset(DynamicAssetsKeys.calculatorResultsLogoComponent);
  const tableData: Array<Array<React.ReactElement>> = getPartnerAsset<Function>(
    DynamicAssetsKeys.calculatorResultsTableData
  )(maxPrice);
  return (
    <Container>
      <QuestionsColumn>
        {tableData.map((row, index) => (
          <FeatureQuestion key={index}>{row[0]}</FeatureQuestion>
        ))}
      </QuestionsColumn>
      <AsurionColumn hasShadow>
        <LogoContainer>
          <Logo />
        </LogoContainer>
        {tableData.map((row, index) => (
          <FeatureAsurion key={index}>{row[1]}</FeatureAsurion>
        ))}
      </AsurionColumn>
      {competitionMonthlyPrices && (
        <CompetitorColumn hasShadow>
          <IndividualWarranties>
            {getPartnerAsset(DynamicAssetsKeys.calculatorResultsIndividualHeading)}
          </IndividualWarranties>
          {tableData.map((row, index) => (
            <FeatureCompetitor key={index}>{row[2]}</FeatureCompetitor>
          ))}
        </CompetitorColumn>
      )}
    </Container>
  );
};

export default CalculatorResultsTable;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/calculator/results/components/CalculatorResultsTable.tsx